var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultProfileBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 776,
    height: 200,
    viewBox: "0 0 776 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8455_31552)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8455_31552",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 776,
    height: 345
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.625,
    width: 775,
    height: 343.906,
    fill: "#F4ECE4"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8455_31552)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.368 169.5C29.52 169.5 35.3179 175.298 35.3179 182.45C35.3179 189.602 29.52 195.4 22.368 195.4L9.41823 195.4L9.41823 182.45C9.41823 175.298 15.2161 169.5 22.368 169.5Z",
    fill: "#0FBC71",
    fillOpacity: 0.13
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M294.445 169.5C301.597 169.5 307.395 175.298 307.395 182.45C307.395 189.602 301.597 195.4 294.445 195.4L281.495 195.4L281.495 182.45C281.495 175.298 287.293 169.5 294.445 169.5Z",
    fill: "#0FBC71",
    fillOpacity: 0.13
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M566.522 169.5C573.674 169.5 579.472 175.298 579.472 182.45C579.472 189.602 573.674 195.4 566.522 195.4L553.572 195.4L553.572 182.45C553.572 175.298 559.37 169.5 566.522 169.5Z",
    fill: "#0FBC71",
    fillOpacity: 0.13
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.368 32.0234C29.52 32.0234 35.3179 37.8213 35.3179 44.9733C35.3179 52.1252 29.52 57.9231 22.368 57.9231L9.41823 57.9231L9.41823 44.9733C9.41823 37.8213 15.2161 32.0234 22.368 32.0234Z",
    fill: "#0FBC71",
    fillOpacity: 0.13
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M294.445 32.0234C301.597 32.0234 307.395 37.8213 307.395 44.9733C307.395 52.1252 301.597 57.9231 294.445 57.9231L281.495 57.9231L281.495 44.9733C281.495 37.8213 287.293 32.0234 294.445 32.0234Z",
    fill: "#0FBC71",
    fillOpacity: 0.13
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M566.522 32.0234C573.674 32.0234 579.472 37.8213 579.472 44.9733C579.472 52.1252 573.674 57.9231 566.522 57.9231L553.572 57.9231L553.572 44.9733C553.572 37.8213 559.37 32.0234 566.522 32.0234Z",
    fill: "#0FBC71",
    fillOpacity: 0.13
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M158.579 169.5C165.731 169.5 171.529 175.298 171.529 182.45C171.529 189.602 165.731 195.4 158.579 195.4L145.629 195.4L145.629 182.45C145.629 175.298 151.427 169.5 158.579 169.5Z",
    fill: "#0FBC71",
    fillOpacity: 0.13
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M430.656 169.5C437.808 169.5 443.606 175.298 443.606 182.45C443.606 189.602 437.808 195.4 430.656 195.4L417.707 195.4L417.707 182.45C417.707 175.298 423.504 169.5 430.656 169.5Z",
    fill: "#0FBC71",
    fillOpacity: 0.13
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M702.733 169.5C709.885 169.5 715.683 175.298 715.683 182.45C715.683 189.602 709.885 195.4 702.733 195.4L689.783 195.4L689.783 182.45C689.783 175.298 695.581 169.5 702.733 169.5Z",
    fill: "#0FBC71",
    fillOpacity: 0.13
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M158.579 32.0234C165.731 32.0234 171.529 37.8213 171.529 44.9733C171.529 52.1252 165.731 57.9231 158.579 57.9231L145.629 57.9231L145.629 44.9733C145.629 37.8213 151.427 32.0234 158.579 32.0234Z",
    fill: "#0FBC71",
    fillOpacity: 0.13
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M430.656 32.0234C437.808 32.0234 443.606 37.8213 443.606 44.9733C443.606 52.1252 437.808 57.9231 430.656 57.9231L417.707 57.9231L417.707 44.9733C417.707 37.8213 423.504 32.0234 430.656 32.0234Z",
    fill: "#0FBC71",
    fillOpacity: 0.13
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M702.733 32.0234C709.885 32.0234 715.683 37.8213 715.683 44.9733C715.683 52.1252 709.885 57.9231 702.733 57.9231L689.783 57.9231L689.783 44.9733C689.783 37.8213 695.581 32.0234 702.733 32.0234Z",
    fill: "#0FBC71",
    fillOpacity: 0.13
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9641 76.5541C51.9641 83.7061 57.7619 89.5039 64.9139 89.5039C72.0659 89.5039 77.8638 83.7061 77.8638 76.5541V63.6043H64.9139C57.7619 63.6043 51.9641 69.4021 51.9641 76.5541Z",
    fill: "#0FBC71",
    fillOpacity: 0.13
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M324.041 76.5541C324.041 83.7061 329.839 89.5039 336.991 89.5039C344.143 89.5039 349.941 83.7061 349.941 76.5541V63.6043H336.991C329.839 63.6043 324.041 69.4021 324.041 76.5541Z",
    fill: "#0FBC71",
    fillOpacity: 0.13
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M596.118 76.5541C596.118 83.7061 601.916 89.5039 609.068 89.5039C616.22 89.5039 622.018 83.7061 622.018 76.5541V63.6043H609.068C601.916 63.6043 596.118 69.4021 596.118 76.5541Z",
    fill: "#0FBC71",
    fillOpacity: 0.13
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M188.176 76.5541C188.176 83.7061 193.973 89.5039 201.125 89.5039C208.277 89.5039 214.075 83.7061 214.075 76.5541V63.6043H201.125C193.973 63.6043 188.176 69.4021 188.176 76.5541Z",
    fill: "#0FBC71",
    fillOpacity: 0.13
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M460.253 76.5541C460.253 83.7061 466.051 89.5039 473.203 89.5039C480.354 89.5039 486.152 83.7061 486.152 76.5541V63.6043H473.203C466.051 63.6043 460.253 69.4021 460.253 76.5541Z",
    fill: "#0FBC71",
    fillOpacity: 0.13
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M732.33 76.5541C732.33 83.7061 738.128 89.5039 745.28 89.5039C752.432 89.5039 758.229 83.7061 758.229 76.5541V63.6043H745.28C738.128 63.6043 732.33 69.4021 732.33 76.5541Z",
    fill: "#0FBC71",
    fillOpacity: 0.13
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M-3.53173 125.375C3.62026 125.375 9.41809 119.577 9.41809 112.425C9.41809 105.273 3.62026 99.4754 -3.53173 99.4754L-16.4816 99.4754L-16.4816 112.425C-16.4816 119.577 -10.6837 125.375 -3.53173 125.375Z",
    fill: "#0FBC71",
    fillOpacity: 0.13
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M268.545 125.375C275.697 125.375 281.495 119.577 281.495 112.425C281.495 105.273 275.697 99.4754 268.545 99.4754L255.595 99.4754L255.595 112.425C255.595 119.577 261.393 125.375 268.545 125.375Z",
    fill: "#0FBC71",
    fillOpacity: 0.13
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M540.622 125.375C547.774 125.375 553.572 119.577 553.572 112.425C553.572 105.273 547.774 99.4754 540.622 99.4754L527.672 99.4754L527.672 112.425C527.672 119.577 533.47 125.375 540.622 125.375Z",
    fill: "#0FBC71",
    fillOpacity: 0.13
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M132.334 125.375C139.486 125.375 145.284 119.577 145.284 112.425C145.284 105.273 139.486 99.4754 132.334 99.4754L119.384 99.4754L119.384 112.425C119.384 119.577 125.182 125.375 132.334 125.375Z",
    fill: "#0FBC71",
    fillOpacity: 0.13
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M404.411 125.375C411.563 125.375 417.361 119.577 417.361 112.425C417.361 105.273 411.563 99.4754 404.411 99.4754L391.461 99.4754L391.461 112.425C391.461 119.577 397.259 125.375 404.411 125.375Z",
    fill: "#0FBC71",
    fillOpacity: 0.13
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M676.488 125.375C683.64 125.375 689.438 119.577 689.438 112.425C689.438 105.273 683.64 99.4754 676.488 99.4754L663.539 99.4754L663.539 112.425C663.539 119.577 669.336 125.375 676.488 125.375Z",
    fill: "#0FBC71",
    fillOpacity: 0.13
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M85.8468 150.508C85.8468 143.356 91.6446 137.559 98.7966 137.559C105.949 137.559 111.746 143.356 111.746 150.508V163.458H98.7966C91.6446 163.458 85.8468 157.66 85.8468 150.508Z",
    fill: "#0FBC71",
    fillOpacity: 0.13
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M357.924 150.508C357.924 143.356 363.722 137.559 370.874 137.559C378.026 137.559 383.824 143.356 383.824 150.508V163.458H370.874C363.722 163.458 357.924 157.66 357.924 150.508Z",
    fill: "#0FBC71",
    fillOpacity: 0.13
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M630.001 150.508C630.001 143.356 635.799 137.559 642.951 137.559C650.103 137.559 655.9 143.356 655.9 150.508V163.458H642.951C635.799 163.458 630.001 157.66 630.001 150.508Z",
    fill: "#0FBC71",
    fillOpacity: 0.13
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M222.059 150.508C222.059 143.356 227.856 137.559 235.008 137.559C242.16 137.559 247.958 143.356 247.958 150.508V163.458H235.008C227.856 163.458 222.059 157.66 222.059 150.508Z",
    fill: "#0FBC71",
    fillOpacity: 0.13
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M494.135 150.508C494.135 143.356 499.933 137.559 507.085 137.559C514.237 137.559 520.035 143.356 520.035 150.508V163.458H507.085C499.933 163.458 494.135 157.66 494.135 150.508Z",
    fill: "#0FBC71",
    fillOpacity: 0.13
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M766.212 150.508C766.212 143.356 772.01 137.559 779.162 137.559C786.314 137.559 792.112 143.356 792.112 150.508V163.458H779.162C772.01 163.458 766.212 157.66 766.212 150.508Z",
    fill: "#0FBC71",
    fillOpacity: 0.13
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M222.059 14.6529C222.059 7.50096 227.856 1.70313 235.008 1.70313C242.16 1.70313 247.958 7.50096 247.958 14.6529V27.6028H235.008C227.856 27.6028 222.059 21.8049 222.059 14.6529Z",
    fill: "#0FBC71",
    fillOpacity: 0.13
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M494.135 14.6529C494.135 7.50096 499.933 1.70313 507.085 1.70313C514.237 1.70313 520.035 7.50096 520.035 14.6529V27.6028H507.085C499.933 27.6028 494.135 21.8049 494.135 14.6529Z",
    fill: "#0FBC71",
    fillOpacity: 0.13
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M766.212 14.6529C766.212 7.50096 772.01 1.70313 779.162 1.70313C786.314 1.70313 792.112 7.50096 792.112 14.6529V27.6028H779.162C772.01 27.6028 766.212 21.8049 766.212 14.6529Z",
    fill: "#0FBC71",
    fillOpacity: 0.13
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M85.8468 14.6529C85.8468 7.50096 91.6446 1.70313 98.7966 1.70313C105.949 1.70313 111.746 7.50096 111.746 14.6529V27.6028H98.7966C91.6446 27.6028 85.8468 21.8049 85.8468 14.6529Z",
    fill: "#0FBC71",
    fillOpacity: 0.13
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M357.924 14.6529C357.924 7.50096 363.722 1.70313 370.874 1.70313C378.026 1.70313 383.824 7.50096 383.824 14.6529V27.6028H370.874C363.722 27.6028 357.924 21.8049 357.924 14.6529Z",
    fill: "#0FBC71",
    fillOpacity: 0.13
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M630.001 14.6529C630.001 7.50096 635.799 1.70313 642.951 1.70313C650.103 1.70313 655.9 7.50096 655.9 14.6529V27.6028H642.951C635.799 27.6028 630.001 21.8049 630.001 14.6529Z",
    fill: "#0FBC71",
    fillOpacity: 0.13
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.39
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.625,
    width: 774.846,
    height: 198.633,
    fill: "#0FBC71",
    fillOpacity: 0.3,
    style: {
      mixBlendMode: "multiply"
    }
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8455_31552"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 775,
    height: 199,
    fill: "white",
    transform: "translate(0.5 0.625)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultProfileBg);
export default __webpack_public_path__ + "static/media/default_profile_bg.9b866147a748fc889206829f9bb6cb54.svg";
export { ForwardRef as ReactComponent };